var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeypad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,6A2.5,2.5,0,1,1,6,3.5,2.5,2.5,0,0,1,3.5,6Zm0-4A1.5,1.5,0,1,0,5,3.5,1.5,1.5,0,0,0,3.5,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,6A2.5,2.5,0,1,1,19,3.5,2.5,2.5,0,0,1,16.5,6Zm0-4A1.5,1.5,0,1,0,18,3.5,1.5,1.5,0,0,0,16.5,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,10,6Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,10,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,19A2.5,2.5,0,1,1,6,16.5,2.5,2.5,0,0,1,3.5,19Zm0-4A1.5,1.5,0,1,0,5,16.5,1.5,1.5,0,0,0,3.5,15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,19A2.5,2.5,0,1,1,19,16.5,2.5,2.5,0,0,1,16.5,19Zm0-4A1.5,1.5,0,1,0,18,16.5,1.5,1.5,0,0,0,16.5,15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10,19a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,10,19Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,10,15Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,12.5A2.5,2.5,0,1,1,6,10,2.5,2.5,0,0,1,3.5,12.5Zm0-4A1.5,1.5,0,1,0,5,10,1.5,1.5,0,0,0,3.5,8.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,12.5A2.5,2.5,0,1,1,19,10,2.5,2.5,0,0,1,16.5,12.5Zm0-4A1.5,1.5,0,1,0,18,10,1.5,1.5,0,0,0,16.5,8.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10,12.5A2.5,2.5,0,1,1,12.5,10,2.5,2.5,0,0,1,10,12.5Zm0-4A1.5,1.5,0,1,0,11.5,10,1.5,1.5,0,0,0,10,8.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypad);
export default __webpack_public_path__ + "static/media/Keypad.215df53e4d2816e85cf2d5623d181c18.svg";
export { ForwardRef as ReactComponent };